/**
 * Product Sales Report Store
 *
 * Zustand store for Product Sales Report feature state management
 */

import {create} from 'zustand';
import {
  ProductSalesReportData,
  ProductSalesReportFilters
} from '../models/productSalesReport.model';

interface ProductSalesReportState {
  // Data
  reportData: ProductSalesReportData | null;

  // Loading states
  isLoading: boolean;

  // Error states
  error: string | null;

  // Filters
  filters: ProductSalesReportFilters;

  // Actions
  setReportData: (data: ProductSalesReportData | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setFilters: (filters: ProductSalesReportFilters) => void;
  clearFilters: () => void;
  reset: () => void;
}

export const useProductSalesReportStore = create<ProductSalesReportState>((set) => {
  return {
    // Initial state
    reportData: null,
    isLoading: false,
    error: null,
    filters: {},

    // Actions
    setReportData: (data) => set({reportData: data}),
    setLoading: (loading) => set({isLoading: loading}),
    setError: (error) => set({error}),
    setFilters: (filters) => set({filters}),
    clearFilters: () => set({filters: {}}),
    reset: () => set({
      reportData: null,
      isLoading: false,
      error: null,
      filters: {}
    })
  };
});

